import { useCallback } from 'react';

import Modal from 'presentation/components/Modal/Modal';
import KSButton from 'presentation/components/KSButton';
import Loading from 'components/Loading';

import { useSendPasswordResetEmail } from 'hooks/useSendPasswordResetEmail';

import './AddLocationModal.scss';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  email: string;
}

export default function ResetPasswordModal({ isOpen, onClose, email }: Props) {
  const { mutate: sendPasswordResetEmail, isPending } = useSendPasswordResetEmail();

  const handleSubmit = useCallback(() => {
    sendPasswordResetEmail({ email }, { onSuccess: onClose });
  }, [email, sendPasswordResetEmail, onClose]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={
        <>
          <div className="ks-modal__title">
            <div className="ks-modal__title-main">Reset Password</div>
          </div>
          <button className="ks-modal__close" onClick={onClose} aria-label="Close modal">
            ×
          </button>
        </>
      }
    >
      <div className="users-admin-add-form__wrapper">
        {isPending && (
          <div className="users-admin-add-form__overlay">
            <Loading loadingCircleClass="Loading-circle-medium" />
          </div>
        )}
        <div className="users-admin-container__form users-admin-add-form reset-password">
          <div className="users-admin-add-form__intro">
            <p className="users-admin-container__form-title">
              Do you want to send a 'Set Password' email to: <strong>{email}</strong>?
            </p>
          </div>

          <div className="ks-modal__footer" style={{ justifyContent: 'flex-end' }}>
            <KSButton onClick={onClose} label="Cancel" color="secondary" size="medium" />
            <KSButton onClick={handleSubmit} disabled={isPending || !email} label="Send Email" color="active" />
          </div>
        </div>
      </div>
    </Modal>
  );
}
